import * as React from 'react';
import { Link } from 'gatsby-plugin-react-intl';
import * as styles from './button-link.module.scss';

interface IProps {
  children: React.ReactNode;
  to: string;
  color?: 'primary' | 'secondary';
  className?: string;
}
export const ButtonLink = ({
  children,
  className = '',
  color = 'primary',
  to,
  ...props
}: IProps) => {
  return (
    <Link
      {...props}
      className={`${color === 'primary' ? styles.primary : styles.secondary} ${
        styles.general
      } ${className}`}
      to={to}
    >
      {children}
    </Link>
  );
};
